import { render, staticRenderFns } from "./lives.vue?vue&type=template&id=1233de00&scoped=true"
import script from "./lives.vue?vue&type=script&lang=js"
export * from "./lives.vue?vue&type=script&lang=js"
import style0 from "./lives.vue?vue&type=style&index=0&id=1233de00&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1233de00",
  null
  
)

export default component.exports